export const COMMENT_ITEM_INFO_CONSTS = {
  goToNewsEditingMsg: 'Перейти в модерацию комментариев новости',
  itsAnswer: 'это ответ',
  noData: '<нет данных>',
  publicationNotFound: 'Публикация не найдена'
}
